import React, { useState, useEffect } from 'react';
import ImageLoad from 'components/ImageLoad';
import notImage from 'images/foto_en_preparacion.png';
import PropTypes from 'prop-types';
import Link from "components/Link";
import CmsService from 'services/CMS';
import TagManagerService from 'services/TagManager';
import PubSub from 'services/PubSub';
import {actionsType, ecommerce} from 'config/constants';
import style from './style.scss'; //NOSONAR

let actions = [];

const ShortBanner = (props) => {
    const [notView, setNotView] = useState(false);

    let data = props.data ? props.data : {image: ''};
    let id = ''

    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        id = data.imagen_mobile ? data.imagen_mobile.split('/').pop() : ''
    } else {
        id = data.image ? data.image.split('/').pop() : ''
    }

    const validSeller = (item) => {
        if(!ecommerce.whiteLabel) return true;

        const validation = item && item.seller ? item.seller : null; 
        return CmsService.validSellerItem(validation);
    }

    const verifySeller = (item) => {
        setNotView(!validSeller(item));
        
    }

    useEffect(() => {
        verifySeller(data);
        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, () => {
            verifySeller(data);
        }));
        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);
    
    const promotionsClick = (item) => {
        item.title = item.title ? item.title : id;
        item.id = id
        TagManagerService.promotionsClick(item, 'slot' + props.data.countShortB, 'Huincha '+ props.data.countShortB );  
    }
    
    let imageResponsive = {
        860: data.imagen_mobile || data.image_mobile,
        1440: data.image ? data.image : ''
    };
    
    let shortBannerAlt = data ? data.title : data.image;
    
    const gtmData = {
        id,
        name: (data.title === '') ? id : data.title,
        creative: 'Huincha ' + data.countShortB,
        position: 'slot' + data.countShortB,
        type: 'shortBanner'
    }

    if(notView) return '';

    return (
        <section className="short-banner" >
            <div className="col" key={data.image.id} onClick={() => promotionsClick(data)} >
                <Link to={data.url} target={data.url_target} className="adaptive-image"  aria-label={data.title ? data.title : data.url}>
                    {data.image && <ImageLoad src={data.image} srcSet={imageResponsive} alt={shortBannerAlt} gtmData={gtmData} />}
                    {!data.image && <img src={notImage} />}
                </Link>
            </div>
        </section>
    )

}

ShortBanner.propTypes = {
    data: PropTypes.object
}
export default ShortBanner;
